// This file is automatically generated by scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

/** @public */
export const LANGUAGES = [
	{ locale: 'id', label: 'Bahasa Indonesia' },
	{ locale: 'ca', label: 'Català' },
	{ locale: 'cs', label: 'Čeština' },
	{ locale: 'da', label: 'Danish' },
	{ locale: 'de', label: 'Deutsch' },
	{ locale: 'en', label: 'English' },
	{ locale: 'es', label: 'Español' },
	{ locale: 'fr', label: 'Français' },
	{ locale: 'gl', label: 'Galego' },
	{ locale: 'hr', label: 'Hrvatski' },
	{ locale: 'it', label: 'Italiano' },
	{ locale: 'hu', label: 'Magyar' },
	{ locale: 'no', label: 'Norwegian' },
	{ locale: 'pl', label: 'Polski' },
	{ locale: 'pt-br', label: 'Português - Brasil' },
	{ locale: 'pt-pt', label: 'Português - Europeu' },
	{ locale: 'ro', label: 'Română' },
	{ locale: 'ru', label: 'Russian' },
	{ locale: 'sl', label: 'Slovenščina' },
	{ locale: 'fi', label: 'Suomi' },
	{ locale: 'sv', label: 'Svenska' },
	{ locale: 'vi', label: 'Tiếng Việt' },
	{ locale: 'tr', label: 'Türkçe' },
	{ locale: 'uk', label: 'Ukrainian' },
	{ locale: 'he', label: 'עברית' },
	{ locale: 'ar', label: 'عربي' },
	{ locale: 'fa', label: 'فارسی' },
	{ locale: 'ku', label: 'کوردی' },
	{ locale: 'ne', label: 'नेपाली' },
	{ locale: 'hi-in', label: 'हिन्दी' },
	{ locale: 'te', label: 'తెలుగు' },
	{ locale: 'th', label: 'ภาษาไทย' },
	{ locale: 'my', label: 'မြန်မာစာ' },
	{ locale: 'ko-kr', label: '한국어' },
	{ locale: 'ja', label: '日本語' },
	{ locale: 'zh-cn', label: '简体中文' },
	{ locale: 'zh-tw', label: '繁體中文 (台灣)' },
] as const
